export type BlogStatus = "draft" | "scheduled" | "published";

const STYLES: Record<BlogStatus, { label: string; cls: string }> = {
  published: {
    label: "Published",
    cls: "text-sage [&_.dot]:bg-sage",
  },
  scheduled: {
    label: "Scheduled",
    cls: "text-tide [&_.dot]:bg-tide",
  },
  draft: {
    label: "Draft",
    cls: "text-ink-4 [&_.dot]:bg-ink-5",
  },
};

/**
 * Inline status pill used in the blog post row. Matches the mock's
 * subdued treatment — no background fill, just a colored dot + label —
 * so the post title stays the visual anchor of each row.
 */
export function StatusPill({ status }: { status: BlogStatus }) {
  const { label, cls } = STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[11px] font-medium ${cls}`}
    >
      <span className="dot inline-block h-[6px] w-[6px] rounded-full" />
      {label}
    </span>
  );
}
